import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import {
  Error,
  selectFormat,
  MAIN_COLORS,
  getMetricForColumn,
  sortNumeric,
} from "components/Utils/Utils.js";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

class LeeFirstOfferConversion extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  headerFormatter(column, colIndex, index, firstRow) {
    const columnToShow = column.text === "Week 1";

    return (
      <>
        <div
          style={{
            backgroundColor: MAIN_COLORS[index],
            color: "#fff",
            padding: "5px",
          }}
        >
          {columnToShow && (
            <div
              style={{
                fontSize: "13px",
                textTransform: "uppercase",
                fontFamily: "Museo Slab W01",
                fontWeight: "bold",
              }}
            >
              {column.dataField.split(".")[0].split("_").join(" ")}
            </div>
          )}
          {column.text}
        </div>
      </>
    );
  }

  sortFunc = (a, b, order, dataField, x, y) => {
    let compare = 0;
    if (x.id === 0 || y.id === 0) {
      return 0;
    }

    if (order === "asc") {
      if (a < b) {
        compare = -1;
      } else if (a > b) {
        compare = 1;
      }
    } else if (order === "desc") {
      if (a < b) {
        compare = 1;
      } else if (a > b) {
        compare = -1;
      }
    }

    return compare;
  };

  renderTable = (data) => {
    const { title } = this.props;
    const firstRow = data[0];

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const firstElement = { ...data[0] };
    delete firstElement.system;
    delete firstElement.offer;
    delete firstElement.weekly_rate;

    const groupedColumns = [];
    Object.keys(firstElement).forEach((key, index) => {
      Object.keys(firstElement[key]).forEach((fKey) => {
        groupedColumns.push({
          dataField: key + "." + fKey,
          text: fKey,
          style: {
            width: "120px",
            minWidth: "120px",
            textAlign: "left",
            backgroundColor: "#f2f2f2",
          },
          headerAlign: "left",
          align: "center",
          formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
          headerFormatter: (column, colIndex) =>
            this.headerFormatter(column, colIndex, index, firstRow),
          sort: true,
        });
      });
    });

    const filter = textFilter({
      getFilter: (filter) => filter,
      placeholder: " ",
      className: "custom-table-filter-input no-border small",
      caseSensitive: false,
    });

    const columns = [
      {
        dataField: "system",
        text: "System",
        style: {
          width: "120px",
          minWidth: "120px",
          textAlign: "left",
        },
        filter,
        headerAlign: "left",
        sort: true,
      },
      {
        dataField: "offer",
        text: "Offer",
        style: {
          width: "150px",
          minWidth: "150px",
          textAlign: "left",
        },
        filter,
        headerAlign: "left",
        sort: true,
      },
      {
        dataField: "weekly_rate",
        text: "Weekly Rate",
        style: { width: "100px", minWidth: "100px" },
        formatter: (cell, row, rowIndex, params) =>
          cell.value === "All"
            ? "All"
            : getMetricForColumn(cell, row, rowIndex, params),
        formatExtraData: { type: "currency" },
        csvFormatter: (cell) =>
          selectFormat("currency", cell && cell.value, "$0,00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      ...groupedColumns,
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <>
            <BootstrapTable
              {...props.baseProps}
              {...props.csvProps}
              wrapperClasses="world-cup-sticky-table-header"
              filter={filterFactory()}
              ref={(el) => (this.childRef = el)}
              sort={{
                sort: true,
                sortFunc: this.sortFunc,
              }}
            />
          </>
        )}
      </ToolkitProvider>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const data = this.props.data.list || this.props.data.data;

    if (data.hasData === false) {
      return <Error minHeight={560} />;
    }

    return (
      <div className="world-cup-actual-estimates-table">
        {this.renderTable(data)}
      </div>
    );
  }
}

export default LeeFirstOfferConversion;
